export default __webpack_public_path__ + "static/media/goal-completed.ab8ab951.svg";